import { render, staticRenderFns } from "./ArtistBlock.vue?vue&type=template&id=cc56f7ca&scoped=true"
import script from "./ArtistBlock.vue?vue&type=script&lang=ts"
export * from "./ArtistBlock.vue?vue&type=script&lang=ts"
import style0 from "./ArtistBlock.vue?vue&type=style&index=0&id=cc56f7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc56f7ca",
  null
  
)

export default component.exports